import React, { Component } from 'react'
import styled from 'styled-components'
import IcClose from './images/ic-close.component.svg'

export default class BigModalV2 extends Component {
  state = {
    modalTop: null,
  }

  componentDidMount() {
    this.calculateModalPosition()
    this.sendModalOpen()
  }

  componentWillUnmount() {
    this.sendModalHide()
    this.props.setModalTriggerHeight(null)
  }

  calculateModalPosition = () => {
    if (this.modalRef) {
      const modalHeight = this.modalRef.offsetHeight
      const viewportHeight = window.innerHeight
      const availableSpaceBelow = viewportHeight - this.props.modalTriggerHeight

      let topPosition = this.props.modalTriggerHeight

      if (availableSpaceBelow < modalHeight) {
        const missingSpace = modalHeight - availableSpaceBelow
        // Not enough space below, position above the button
        topPosition = Math.max(0, this.props.modalTriggerHeight - missingSpace)
      }

      this.setState({ modalTop: topPosition })
    }
  }

  sendModalHide = () => {
    window.parent.postMessage({ type: 'sendModalHide', payload: true }, '*')
  }

  sendModalOpen = () => {
    window.parent.postMessage(
      { type: 'sendModalOpen', height: this.props.modalTriggerHeight },
      '*'
    )
  }

  render() {
    const { title, onClose, children, ...restProps } = this.props
    const { modalTop } = this.state

    return (
      <WrapperBg onMouseDown={onClose}>
        <Wrapper
          scrollPosition={modalTop}
          innerRef={(ref) => (this.modalRef = ref)}
          {...restProps}
          onMouseDown={(e) => e.stopPropagation()}>
          <TitleRow>
            <h1>{title}</h1>
            <span>
              <IcClose onClick={onClose} />
            </span>
          </TitleRow>
          <Content>{children}</Content>
        </Wrapper>
      </WrapperBg>
    )
  }
}

const WrapperBg = styled.div`
  background-color: #25272ca3;
  position: fixed;
  inset: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Wrapper = styled.div.attrs({ ref: (props) => props.forwardedRef })`
  display: flex;
  padding: 24px 24px 16px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 700px;
  height: 700px;

  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  top: ${({ scrollPosition }) => scrollPosition}px;

  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);
  background: #fff;
`

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  h1 {
    color: #010101;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 140% */
    text-transform: uppercase;
    margin: 0;
  }

  span {
    cursor: pointer;
  }
`

const Content = styled.div`
  display: flex;
  flex: 1 0 0;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/BigModalV2/index.js